export default __webpack_public_path__ + "static/03-ecf241d5520c593dab2a5d5bb5d1f3a3.png";